// @flow
import { createContext } from 'react';

export const EstimateContext = createContext({});
